import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import { ToastContainer, Bounce } from "react-toastify";
import Swap from "./components/Swap";
import Pool from "./components/Pool";
import Deposit from "./components/Deposit";
import AddLiquidity from "./components/AddLiquidity";
import RemoveLiquidity from "./components/RemoveLiquidity";
import Layout from "./components/Layout";
import Landing from "./components/Landing";
import Ecosystem from "./components/Ecosystem";
import LiFiBridge from "./components/LiFiBridge";
import SumsubVerification from "./components/kyc";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";

/* Lives inside ThemeProvider so toasts follow the active palette. */
const ThemedToasts = () => {
    const { theme } = useTheme();
    return (
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme={theme}
            transition={Bounce}
        />
    );
};

function App() {
    return (
        <ThemeProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        {/* The landing page is the default surface. It redirects
                            rather than rendering at "/" so the page keeps one
                            canonical URL instead of answering on two. */}
                        <Route path="/" element={<Navigate to="/landing" replace />} />
                        <Route
                            path="/landing"
                            element={
                                <Layout>
                                    <Landing />
                                </Layout>
                            }
                        />
                        <Route
                            path="/swap"
                            element={
                                <Layout>
                                    <Swap />
                                </Layout>
                            }
                        />
                        <Route
                            path="/pool"
                            element={
                                <Layout>
                                    <Pool />
                                </Layout>
                            }
                        />
                        <Route
                            path="/pool/addliquidity/:address1/:address2"
                            element={
                                <Layout>
                                    <AddLiquidity />
                                </Layout>
                            }
                        />
                        <Route
                            path="/remove/liquidity/:pairAddress"
                            element={
                                <Layout>
                                    <RemoveLiquidity />
                                </Layout>
                            }
                        />
                        <Route
                            path="/kyc"
                            element={
                                <Layout>
                                    <SumsubVerification />
                                </Layout>
                            }
                        />
                        <Route
                            path="/deposit"
                            element={
                                <Layout>
                                    <Deposit />
                                </Layout>
                            }
                        />
                        {/* The bridge has to live under a splat path: the widget
                            reuses the host's router when there is one (AppProvider
                            picks Fragment over MemoryRouter inside a router
                            context), so its internal pages — from-token, to-token,
                            settings — are pushed into the real URL. Anything but a
                            trailing "*" leaves those unmatched and the whole tree
                            renders blank. "/bridge/*" matches /bridge itself too. */}
                        <Route
                            path="/bridge/*"
                            element={
                                <Layout>
                                    <LiFiBridge />
                                </Layout>
                            }
                        />
                        <Route
                            path="/ecosystem"
                            element={
                                <Layout>
                                    <Ecosystem />
                                </Layout>
                            }
                        />
                    </Routes>
                </BrowserRouter>
                <ThemedToasts />
            </div>
        </ThemeProvider>
    );
}

export default App;
